import { FC, ReactNode, useContext, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import Sidebar from './Sidebar';
import Header from './Header';
import { CollapseContext } from 'src/contexts/CollapseContext';
import SideDrawer from './SideDrawer/SideDrawer';

interface SidebarLayoutProps {
  children?: ReactNode;
}

const MainContent = styled(Box)(
  ({ theme }) => `
        margin-top: ${theme.header.height};
        flex: 1 1 auto;
        overflow: auto;
`
);

const SidebarLayout: FC<SidebarLayoutProps> = () => {
  const { collapseToggle, toggleCollapse } = useContext(CollapseContext);
  const [isClickedMenuItem, setIsClickedMenuItem] = useState<boolean>(false);

  const menuItemHandler = (value) => {
    setIsClickedMenuItem(value);
  };

  const closeSideBarHandler = (value) => {
    if(value) {
      setIsClickedMenuItem(false);
    }
  };

  const MainWrapper = styled(Box)(
    ({ theme }) => `
          flex: 1 1 auto;
          display: flex;
          height: 100%;
          padding-left: ${!collapseToggle ? '50px' : '250px'};
          @media (max-width: 1024px) {
              padding-left: 0;
          }
  `
  );

  return (
    <>
      <Sidebar />
      <MainWrapper>
        <Header menuItemHandler={menuItemHandler} />
        {isClickedMenuItem && <SideDrawer closeSideBar={closeSideBarHandler} />}
        <MainContent>
          <Outlet />
        </MainContent>
      </MainWrapper>
    </>
  );
};

export default SidebarLayout;
